import { deleteDismissedData } from "./dismiss";
import { deleteRedirectData } from "./redirect";
import { deleteBounceData } from "./bounce";
import { deleteRecoveryData, getRecoveryData } from "./recovery";
import {
  deleteAttributionExpiry,
  getAttributionExpiry,
} from "./attributionExpiry";
import { deleteSingleClickFlag } from "./singleClick";
import { getLastRenderDate } from "./render";

export function invalidateUserData() {
  deleteRecoveryData();
  deleteRedirectData();
  deleteBounceData();
  deleteAttributionExpiry();
  deleteSingleClickFlag();
  deleteDismissedData();
}

class UserLocalStorageState {}

export function getUserState(): UserLocalStorageState | undefined {
  const renderDate = getLastRenderDate();
  const recoveryType = getRecoveryData();
  const attributionExpiry = getAttributionExpiry();
  if (!renderDate && !recoveryType && !attributionExpiry) {
    // no data found in local storage
    return undefined;
  }
  return {
    recoveryType,
    renderDate,
    attributionExpiry,
  } as UserLocalStorageState;
}
